
import { ONLINE_ONLY, QUICK_DELIVERY_ONLY } from '~/constants'
import { rules } from '~/mixin/common/product/productRules'
import * as ds from '~/scriptData/ds/dsCommon'

export default {
  name: 'ProdFlag',
  mixins: [rules],
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    exhType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ONLINE_ONLY,
      QUICK_DELIVERY_ONLY,
      prodExhType: ds.getProdExhType(this.exhType)
    }
  }
}
